import { Icon, Typography } from "@/components/atoms";
import { clsx } from "@/utils";

const TRUST_ITEMS = [
  { icon: "Airplane", label: "Flight Tracking" },
  { icon: "Car", label: "Licensed Chauffeurs" },
  { icon: "Call", label: "24/7 Support" },
];

/** "We're committed…" reassurance block — shared by both Booking Summary variants. */
export const TrustNote = ({ className }: { className?: string }) => (
  <div className={clsx(className)}>
    <Typography variant="muted" className="block text-neutral-dark-gray">
      We&apos;re committed to giving you a smooth and worry-free journey with:
    </Typography>
    <div className="mt-3 flex flex-col gap-2">
      {TRUST_ITEMS.map((item) => (
        <div key={item.label} className="flex items-center gap-2">
          <Icon name={item.icon} variant="Bold" size="md" className="text-orange" />
          <Typography variant="muted">{item.label}</Typography>
        </div>
      ))}
    </div>
  </div>
);
